<template>
    <Head title="Meu Perfil" />
    <RegisterLayout title="Faça Parte">
        <form class="pb-14 px-4" @submit.prevent="submit">
            <section class="pt-10">
                <p class="text-xl">Preencha os campos abaixo para fazer parte desse <br/> time de campeões.</p>
                <p class="mt-11"><span class="text-red-600">* </span>Campos obrigatórios</p>
            </section>

            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-primary text-left">Perfil</h2>
                <div class="mt-3">
                    <label for="name" class="flex font-bold">Nome Completo<span class="text-red-600 ml-1"> *</span></label>
                    <Input required name="name" placeholder="Exemplo: João da Silva" maxlength="70" type="text" v-model="form.name" />

                    <label class="flex font-bold mt-3">Apelido<span class="text-red-600 ml-1"> *</span></label>
                    <span class="text-[14px]">Como você gostaria de ser chamado dentro da plataforma?</span>
                    <Input required placeholder="Exemplo: Jota" ref="nickname" type="text" maxlength="40" class="mt-2" id="nickname" v-model="form.nickname" />

                    <label class="flex font-bold mt-3"> CPF<span class="text-red-600 ml-1">*</span></label>
                    <Input
                        placeholder="000.000.000-00"
                        @keyup="formatCpf"
                        id="cpf"
                        type="text"
                        v-model="form.cpf"
                        maxlength="14"
                        required
                        autocomplete="cpf"
                    />

                    <label class="flex font-bold mt-3">Data de Nascimento</label>
                    <Input class="max-w-[153px] p-3 rounded-2xl" name="birthDate" placeholder="DD / MM / AAAA" :state="ageError ? 'error' : 'success'" @keydown="formatDate" @change="formatDate" type="text" v-model="form.birthDate" />

                    <label class="flex font-bold mt-3">Código SAP</label>
                    <Input name="sap" placeholder="00000000" type="email" :value="codeSap" disabled/>

                    <label class="flex font-bold mt-3">Cargo</label>
                    <Input name="role" placeholder="Cargo" type="text" v-model="computedJobTitle" disabled/>

                    <label class="flex font-bold mt-3">Regional</label>
                    <Input name="region" placeholder="Região" type="email" :value="region" disabled/>

                    <label class="flex font-bold mt-3">Filial</label>
                    <Input name="filial" placeholder="Filial" type="email" :value="subregion" disabled/>
                </div>
            </section>

            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-left text-primary">Contato</h2>

                    <label class="flex font-bold mt-3">Email</label>
                    <Input required name="email" placeholder="Exemplo: joao@email.com" type="email" v-model="form.email" disabled/>

                    <label for="phoneNumber" class="flex font-bold mt-3">Celular<span class="text-red-600 ml-1"> *</span></label>
                    <Input required name="phoneNumber" placeholder="(00) 00000-0000" type="text" @keypress="formatPhoneNumber" v-model="form.mobile"/>

                    <label for="instagram" class="flex font-bold mt-3">Instagram</label>
                    <div class="flex items-center gap-x-2 mt-1">
                        <span class="text-xl font-bold">@</span>
                        <Input name="instagram" placeholder="nomedoperfil" type="text" v-model="form.instagram"/>
                    </div>
            </section>

            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-primary text-left">Endereço</h2>
                <div class="mt-3">
                    <div class="flex flex-col">
                        <label class="flex font-bold mt-3 ">CEP<span class="text-red-600 ml-1"> *</span></label>
                        <Input required placeholder="00000-000" name="zipCode" type="text" maxlength="9" @keypress="formatPostalCode" @input="getAdress" v-model="this.form.address.zipCode"/>
                        <a class="text-indigo-500" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei meu CEP</a>
                    </div>

                        <label for="address" class="flex font-bold mt-3 "> Endereço<span class="text-red-600 ml-1"> *</span> </label>
                        <Input required name="address" placeholder="Rua das Flores" type="text" v-model="this.form.address.address"/>

                        <div class="flex gap-x-5">
                            <label class="flex flex-col font-bold mt-3 ">
                                <label for="addressNumber" class="flex font-bold "> Número<span class="text-red-600 ml-1"> *</span> </label>
                                <Input required name="addressNumber" placeholder="123" type="text" @keydown="onlyNumbers" @change="onlyNumbers" v-model="this.form.address.number"/>
                            </label>

                            <label for="complement" class="flex flex-col w-full font-bold mt-3">
                                <p>Complemento</p>
                                <Input name="complement" placeholder="Casa, Apartamento, Quadra..." type="text" v-model="this.form.address.complement"/>
                            </label>
                        </div>

                        <label for="district" class="flex font-bold mt-3 "> Bairro<span class="text-red-600 ml-1"> *</span> </label>
                        <Input required name="district" placeholder="São José" type="text" v-model="this.form.address.district"/>

                        <label class="flex font-bold mt-3 ">Cidade<span class="text-red-600 ml-1"> *</span></label>
                        <Autocomplete :isRequired="true" inputName="city" @updateValue="this.form.address.city = $event" :initialValue="this.form.address.city"/>

                        <label class="flex font-bold mt-3 ">Estado<span class="text-red-600 ml-1"> *</span></label>
                        <Select required name="state" placeholder="Selecione um estado" :options="states" class="!w-full" v-model="this.form.address.state"/>
                </div>
            </section>

            <div class="mt-4">
                <p v-for="(error, key) in errors" :key="key" class="text-red-600">{{error}}</p>
                <p class="text-red-600">{{$page.props.flash.error}}</p>
                <p v-if="ageError" class="text-red-600">Idade incorreta</p>
                <p v-if="cpfError" class="text-red-600">Cpf já está em uso por outro participante.</p>
            </div>
            <div class="mt-14">
                <Button>
                    Avançar
                </Button>
            </div>
        </form>
    </RegisterLayout>
</template>

<script>
import RegisterLayout from "@/Layouts/Register.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Input from "@/Components/UI/Form/InputWithoutIcon.vue";
import Select from "@/Components/UI/Form/Select.vue";
import Autocomplete from "@/Components/Autocomplete.vue";
import { formatPhoneNumber, formatLandLine, onlyNumbers, formatPostalCode, formatCpf, formatDate } from "@/Helpers/masks";
import axios from "axios";


export default {

    components: {
        RegisterLayout,
        Head,
        Heading,
        Icon,
        Input,
        Select,
        Autocomplete,
        Button
    },
    props: {
        profile: Object,
        address: Object,
        cpf: Object,
        name: Object,
        email: String,
        role: String,
        jobTitle: String,
        codeSap: String,
        branch: String,
    },
    data() {
        return {
            errors: [],
            ageError: false,
            cpfError: false,
            data:  this.profile,
            hasAddress: false,
            form: this.$inertia.form({
                id: '',
                name: this.name,
                nickname: '',
                birthDate: '',
                cpf: this.cpf ? this.formatInitialCpf(this.cpf) : '',
                email: sessionStorage.getItem('email'),
                codeSap: this.codeSap,
                region: '',
                subregion: '',
                mobile: '',
                instagram: '',
                address: {
                    id: '',
                    zipCode: '',
                    address: '',
                    number: '',
                    complement: '',
                    district: '',
                    city: '',
                    state: '',
                }
            }),
            modelValue: '',
            states: [
                'AC',
                'AL',
                'AP',
                'AM',
                'BA',
                'CE',
                'DF',
                'ES',
                'GO',
                'MA',
                'MS',
                'MT',
                'MG',
                'PA',
                'PB',
                'PR',
                'PE',
                'PI',
                'RJ',
                'RN',
                'RS',
                'RO',
                'RR',
                'SC',
                'SP',
                'SE',
                'TO',
            ]
        }
    },
    computed: {
        computedJobTitle() {
            const jobTitle = this.jobTitle?.toLowerCase();

            if(['repositor', 'promotor'].includes(jobTitle)) {
                return 'MERCHANDISER';
            }

            return this.jobTitle;
        }
    },
    methods: {
        quit() {
            location.href = "/logout";
        },
        submit() {
            let inputs = document.getElementsByTagName('Input');
            this.ageError = false;
            this.cpfError = false;
            this.errors = [];

            let addressInputs = ['zipCode','address','addressNumber', 'complement', 'district', 'city', 'state'];
            let optionalInputs = ['age', 'birthDate', 'instagram', 'sap', 'role', 'region', 'filial'];

            for (var i = 1; i < inputs.length; i++) {
                if(addressInputs.includes(inputs[i].getAttribute('name'))) {
                    if(inputs[i].value) {
                        this.hasAddress = true;
                    }
                }
            }

            if(!this.hasAddress) {
                addressInputs.map(el => optionalInputs.push(el));
            } else {
                optionalInputs = ['age', 'birthDate', 'instagram'];
            }
;
            for (var i = 1; i < inputs.length; i++) {
                if(inputs[i].hasAttribute('required')) {

                    if(!inputs[i].value) {
                        inputs[i].classList.add('border-error');
                        inputs[i].classList.remove('border-gray-800');

                        this.errors = [];
                        this.errors.push(`Preencha todos os campos`)
                    } else {
                        inputs[i].classList.remove('border-error');
                        inputs[i].classList.add('border-gray-800');
                    }
                }
            }

            if (this.form.birthDate && this.form.birthDate.trim() !== '') {
                let arrBirthDate = this.form.birthDate.split('/');
                let date = new Date(arrBirthDate[2], arrBirthDate[1]-1, arrBirthDate[0]);

                this.ageError = !this.verifyAge(new Date(date));
            }

            if(this.errors.length === 0 && this.ageError == false) {
                let split;
                let formatBirthDate;
                if (!this.form.birthDate || this.form.birthDate.trim() !== '') {
                    split = this.form.birthDate.split('/')
                    formatBirthDate = `${split[2]}-${split[1]}-${split[0]}`
                }

                sessionStorage.setItem('name', this.form.name);
                sessionStorage.setItem('nickname', this.form.nickname);
                sessionStorage.setItem('birthDate', formatBirthDate);
                sessionStorage.setItem('mobile', this.form.mobile);
                sessionStorage.setItem('cpf', this.form.cpf.replace('.', '').replace('.', '').replace('-', ''));
                sessionStorage.setItem('email', this.form.email);
                sessionStorage.setItem('instagram', this.form.instagram);
                sessionStorage.setItem('zipCode',this.form.address.zipCode);
                sessionStorage.setItem('address',this.form.address.address);
                sessionStorage.setItem('number',this.form.address.number);
                sessionStorage.setItem('complement',this.form.address?.complement);
                sessionStorage.setItem('district',this.form.address.district);
                sessionStorage.setItem('city',this.form.address.city);
                sessionStorage.setItem('state',this.form.address.state);

                axios.post("/register/validate", {
                    cpf : this.form.cpf.replace('.', '').replace('.', '').replace('-', ''),
                }).then((response) => {
                    console.log(response);
                    if (response.data.success === false){
                        this.form.get(this.route('register.senha'), {
                            cpf: this.form.cpf
                        });
                    }else{
                        this.cpfError = true;
                    }
                });


            }
        },
        verifyAge(birthDate) {

            let dateNow = new Date();
            console.log(dateNow, birthDate);
            console.log(dateNow.getFullYear() - birthDate.getFullYear())

            let yearDif = dateNow.getFullYear() - birthDate.getFullYear();
            let monthDif = dateNow.getMonth() - birthDate.getMonth();
            let dateDif = dateNow.getDate() - birthDate.getDate();

            if(yearDif < 18 || yearDif > 99) {return false};
            if(yearDif > 18) {return true};
            if(yearDif == 18) {
                if(monthDif > 0) {return true};
                if(monthDif < 0) {return false};
                if(monthDif == 0) {
                    if(dateDif >= 0) {return true}
                    else{return false}
                }
            }
        },
        changePassword() {
            this.$inertia.post('/forgot-password', this.form.email);
        },
        hideCpf(cpf) {
            cpf = cpf.replace(/(\d{3})/, "***");
            cpf = cpf.replace(/(\d{3})/, "***");
            return cpf;
        },
        getAdress() {
            if(this.form.address.zipCode.length === 9) {
                const zipCodeFormat =  this.form.address.zipCode.replace('-', '')

                axios
                    .get(`https://viacep.com.br/ws/${zipCodeFormat}/json/`)
                    .then((res) => {
                        this.form.address.address = res.data.logradouro;
                        this.form.address.complement = res.data.complemento;
                        this.form.address.district = res.data.bairro;
                        this.form.address.city = res.data.localidade;
                        this.form.address.state = res.data.uf;
                    })
                    .catch((error) => {
                            console.log(error);
                    });
            }
        },
        imprimir(x) {
            console.log(x)
        },
        formatInitialCpf(cpf) {
            if(!cpf) return '';

            cpf = cpf.replace(/\D/g, "")
            cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
            cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
            cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")

            cpf.substr(0, 14)
            return cpf
        },
        formatPhoneNumber,
        formatLandLine,
        onlyNumbers,
        formatPostalCode,
        formatCpf,
        formatDate
    }
};
</script>
